module.exports = __webpack_public_path__ + "static/img/t1.ff7bc02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/t1.png
// module id = DaXA
// module chunks = 2